import React, { useState } from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import FormSF from '../../../widgets/form/FormSF'
import ALMMetricModalUI from './ALMMetricModalUI.js'
import ModalUI from '../../../widgets/layout/ModalUI.js'
import '../../../components/superUser/loanList/EMITrackerSummary.css'
import './ALMReportPage.css'
import ALMReportTableUI from '../../../components/superUser/loan/ALMReportTableUI'
import ALMReportNavUI from './ALMReportNavUI.js'

const POPUP_SCROLL_THRESHOLD = 10

const PopupTableContainer = ({ recordCount, children }) => (
    <div
        className={recordCount > POPUP_SCROLL_THRESHOLD ? 'emi_popup_table_scroll' : undefined}
        style={{ width: '100%', margin: 0, padding: 0 }}
    >
        {children}
    </div>
)

const DelinquentAccountListPopup = ({ accountList }) => {
    const recordCount = accountList ? accountList.length : 0
    return (
        <PopupTableContainer recordCount={recordCount}>
            <table style={{ width: '100%' }} className='table_cr table'>
                <thead>
                    <tr>
                        <th className='left' style={{ padding: '8px', backgroundColor: '#f5f5f5' }}>Account Name</th>
                    </tr>
                </thead>
                <tbody>
                    {accountList && accountList.length > 0 ? (
                        accountList.map((accountName, idx) => (
                            <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f9f9f9' }}>
                                <td className='left' style={{ padding: '8px' }}>{accountName}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className='left g_muted' style={{ padding: '8px' }}>No delinquent accounts found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </PopupTableContainer>
    )
}

const getDelinquentAccountNameList = (almReport) => {
    if (!almReport) return []
    const map = almReport.allAccounts || almReport.goodStandingAccounts
    if (!map) return []
    const accountNamesSet = new Set()
    Object.values(map).forEach(bucket => {
        const list = (bucket && bucket.delinquentAccountNameList) || (bucket && bucket.delinquentAccountList)
        if (Array.isArray(list)) {
            list.forEach(name => {
                if (name) accountNamesSet.add(name)
            })
        }
    })
    return Array.from(accountNamesSet)
}

const ALMReportPageUI = ({
    context,
    almReport,
    almReportSubmitted,
    almReportErrorList,
    onRefreshClick,

    selectedTab,
    setSelectedTab,

    onUpdateDelinquentSubmit,
    onUpdateDelinquentSubmitted,
    updateDelinquentSuccessMsg,
    updateDelinquentErrorList,


    onAddMetricClick,
    onPendingUpdatesChange,
    onSavePendingUpdates,

    addMetricMode,
    metricType,
    onAddMetricSubmit,
    onAddMetricCancelClick,
    addMetricSubmitted,
    addMetricSuccessMsg,
    addMetricErrorList,
    setAddMetricErrorList,
    metricKey,
    onMetricKeyChange,
    metricKeyError,
    setMetricKeyError,

    saveMetricSubmitted,
    saveMetricSuccessMsg,
    saveMetricErrorList,

    onDownloadClick
}) => {
    const [showDelinquentModal, setShowDelinquentModal] = useState(false)

    const tableKey =
        selectedTab === 'goodStanding'
            ? 'goodStandingAccounts'
            : 'allAccounts'

    const tableTitle =
        selectedTab === 'goodStanding'
            ? 'Good Standing Accounts'
            : 'All Accounts'

    const trackerMap =
        selectedTab === 'goodStanding'
            ? (almReport ? almReport.goodStandingAccounts : null)
            : (almReport ? almReport.allAccounts : null)

    const months = trackerMap
        ? Object.keys(trackerMap).sort()
        : []

    const loanStatusUpdatedDateTimeISO =
        months.length > 0
            ? trackerMap[months[0]].loanStatusUpdatedDateTimeISO
            : null
    console.log("selectedTab in UI:", selectedTab);
    return (
        <SuperUserHomePageUI
            context={context}
            className='pg_su_alm'
            topnav='almbucket'
            centered={!almReport && !almReportErrorList}
            page='almbucket'
            dimension='w1600'
        >

            {
                !almReport &&
                almReportErrorList.length === 0 &&
                <SpinnerComponentUI />
            }

            {
                almReportErrorList.length > 0 &&
                <div className="alm_error_box">
                    {almReportErrorList.map((error, index) => {
                        const msg = error ? (typeof error === 'object' ? error.message || String(error) : error) : ''
                        return msg ? <div key={index}>{msg}</div> : null
                    })}
                </div>

            }

            {
                almReport &&
                <div className='su_alm'>

                    <LRTableActionsUI
                        location='top'
                        left={
                            <span className='g_flex_left g_flex_h'>
                                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                                <IconButtonUI icon='icon-download' onClick={() => onDownloadClick(selectedTab)} label='Download' />
                                <span className='g_m_left_100 g_large'><b>ALM Tracker - Real Time</b></span>
                            </span>
                        }
                        right={
                            <div className='g_text_right'>
                                {
                                    loanStatusUpdatedDateTimeISO &&
                                    <span className='g_m_left_50 g_muted'>Last Updated: {loanStatusUpdatedDateTimeISO}</span>
                                }
                            </div>
                        }
                    />

                    {
                        almReportSubmitted
                            ? <SpinnerComponentUI />
                            :
                            <div className='alm_scroll'>
                                {
                                    <LRTableActionsUI
                                        location='top'
                                        left={
                                            <ALMReportNavUI
                                                selectedTab={selectedTab}
                                                setSelectedTab={setSelectedTab}
                                            />
                                        }
                                    />
                                }
                                <CardUI className='scroll'>
                                    {
                                        saveMetricErrorList.length > 0 &&
                                        <div className="alm_error_box">
                                            {saveMetricErrorList.map((error, index) => {
                                                const msg = error ? (typeof error === 'object' ? error.message || String(error) : error) : ''
                                                return msg ? <div key={index}>{msg}</div> : null
                                            })}
                                        </div>
                                    }
                                    <ALMReportTableUI
                                        tableKey={tableKey}
                                        title={tableTitle}
                                        trackerMap={trackerMap}
                                        onAddMetricClick={onAddMetricClick}
                                        onPendingUpdatesChange={onPendingUpdatesChange}
                                        onSavePendingUpdates={onSavePendingUpdates}
                                        onShowDelinquentClick={() => setShowDelinquentModal(true)}
                                    />

                                </CardUI>
                            </div>

                    }

                    <ALMMetricModalUI
                        context={context}
                        addMetricMode={addMetricMode}
                        metricType={metricType}
                        successMsg={addMetricSuccessMsg}
                        errorList={addMetricErrorList}
                        setErrorList={setAddMetricErrorList}
                        submitted={addMetricSubmitted}
                        onSubmit={onAddMetricSubmit}
                        onCancelClick={onAddMetricCancelClick}
                        metricKey={metricKey}
                        onMetricKeyChange={onMetricKeyChange}
                        metricKeyError={metricKeyError}
                        setMetricKeyError={setMetricKeyError}
                    />

                    {showDelinquentModal && (
                        <ModalUI
                            isOpen={true}
                            onRequestClose={() => setShowDelinquentModal(false)}
                            titleLabel='Delinquent Account List'
                        >
                            <DelinquentAccountListPopup accountList={getDelinquentAccountNameList(almReport)} />
                        </ModalUI>
                    )}

                </div>
            }

        </SuperUserHomePageUI >
    )
}

export default ALMReportPageUI